import Axios from 'axios';
import { Configuration } from "./Configuration";
import {CalcData} from "../../model/clases/CalcData";


class CloseCalcAPI {
  url: string = `${Configuration.apiUrl}/closeCalc.php`;

  close(data: CalcData|undefined): Promise<any> {
    return Axios.post(`${this.url}`, data);
  }
}

export default CloseCalcAPI;
